import { useRender } from '@base-ui/react/use-render'
import { useId } from 'react'

import { cn } from '../../../../lib/utils.ts'

import { useRegisterItemMetadata } from './item-metadata-context.ts'
import { itemTitleVariants } from './item.variants.ts'

export function ItemTitle(props: ItemTitle.Props) {
  const { className, id, ref, ...rest } = props
  const generatedId = useId()
  const resolvedId = id ?? generatedId
  useRegisterItemMetadata('title', resolvedId)
  return useRender({
    ref,
    defaultTagName: 'span',
    props: {
      id: resolvedId,
      'data-slot': 'item-title',
      className: cn(itemTitleVariants(), className),
      ...rest,
    },
  })
}
export namespace ItemTitle {
  export type Props = React.ComponentProps<'span'>
}
